import { Injectable } from '@angular/core';
import { Pagina } from 'src/app/entidades/pagina';
import { Paginator } from 'src/app/entidades/paginator';
import { PermissaoCotar } from 'src/app/entidades/permissaoCotar';
import { ProdutividadeWorkshop } from 'src/app/entidades/produtividadeWorkshop';
import { httpVerb } from 'src/app/enum/httpVerb';
import { ApiService } from '../api/api.service';
import { promise } from 'protractor';

@Injectable({
  providedIn: 'root'
})
export class PermissaoCotarService {

  constructor(private apiService: ApiService) { }

    async Obter(paginator: Paginator): Promise<Pagina<PermissaoCotar> | undefined> {
      try {
        let paginaAtual: Pagina<PermissaoCotar> | undefined = undefined;
        const complemento = `/PermissaoCotar?Pagina=${paginator.pageIndex + 1}&tamanhoPagina=${paginator.pageSize}`;
        await this.apiService.request<Pagina<PermissaoCotar>>(complemento, httpVerb.get)
          .then(result => {
            if (result !== null && result !== undefined) {
              paginaAtual = (result as Pagina<PermissaoCotar>);
            }
          });
  
        return paginaAtual;
      } catch (error) {
        console.log(error);
        return undefined;
      }
    }

    async AddPermissao(codPA: string): Promise<PermissaoCotar | undefined> {
      try {
        let permissao: any = {
          codPA: codPA,
          dataPermissao: new Date().toLocaleString('sv-SE', { timeZone: 'America/Sao_Paulo' }).replace(' ', 'T')         
        }
        let apiResult: PermissaoCotar | undefined = undefined;
        const complemento = `/PermissaoCotar`;
        await this.apiService.request<PermissaoCotar>(complemento, httpVerb.put, permissao)
          .then(result => {
            if (result !== null && result !== undefined) {
              apiResult = (result as PermissaoCotar);
            }
          });
  
        return apiResult;
      } catch (error) {
        console.log(error);
        return undefined;
      }
    }

    async RemoverPermissao(codPA: string): Promise<boolean> {
      try {        
        let excluiu: boolean = false;
        const complemento = `/PermissaoCotar/${codPA}`;          
        await this.apiService.request<boolean>(complemento, httpVerb.delete)
          .then(result => {
            if (result !== null && result !== undefined) {
              excluiu = (result as boolean);
            }
          });
  
        return excluiu;
      } catch (error) {
        console.log(error);
        return false;
      }
    }
}
